// @flow
import React, { Component } from 'react'
import moment from 'moment'
import { Redirect, withRouter } from 'react-router-dom'
import { message as antdMessage } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isNullOrUndefined } from 'util'

import SMConst from 'frontend_core/dist/constants/sm-const'
import { imagePath } from 'frontend_core/dist/helpers/image'
import Path from 'routes/path'
import { setUIState, containerIds } from 'redux/modules/ui'
import {
  actions as ReservationDetailActions,
  type State as ReservationDetailState,
} from 'redux/modules/reservationDetail'
import { actions as UserActions } from 'redux/modules/remote/user'
import { actions as MasterActions } from 'redux/modules/remote/master'
import { showErrorMessage } from 'helpers/error'
import CardHelper from 'helpers/CardHelper'

import MainTemplate from 'components/templates/MainTemplate'
import LoadingView from 'components/atoms/LoadingView'
import ReservationPayExaminationPage from 'components/pages/ReservationPayExaminationPage'
import ReservationPayExaminationConfirmPage from 'components/pages/ReservationPayExaminationConfirmPage'
import ReservationPayExaminationFinishPage from 'components/pages/ReservationPayExaminationFinishPage'

import graphql from './graphql'

export type PropTypes = {
  match: {
    params: {
      ownerName: string,
      reservationId: string,
    },
  },
  location: {
    pathname: string,
  },
  history: {
    replace: Function,
    push: Function,
  },
  ui: {
    loading?: ?boolean,
    confirmActionType?: ?'approve' | 'reject',
    isShowContentsSp?: ?boolean,
    paidExamForm: {},
  },
  actions: {
    setUIState: Function,
    fetchReservationDetail: Function,
    fetchUser: Function,
    fetchLargeAreas: Function,
    createPaidContact: Function,
  },
  user: {},
  reservationDetail: ReservationDetailState,
}

class ReservationPayExaminationContainer extends Component<PropTypes, *, *> {
  requestParams: Object

  componentDidMount() {
    const { actions, reservationDetail, match, data } = this.props
    const { detail, messages } = reservationDetail

    window.scrollTo(0, 0)

    // 直リンの場合の初期データ取得
    if (!detail.id) {
      actions.fetchReservationDetail({
        userId: data.viewer.id,
        reservationId: match.params.reservationId,
      })
    }

    actions.fetchUser({
      userId: data.viewer.id,
      fetched: user => {},
    })

    actions.fetchLargeAreas()
  }

  getPaidExamError = (fieldName: string) => {
    const { ui } = this.props
    const paidExamError = ui.paidExamError || []
    const errors = paidExamError
      .filter(e => e.field === fieldName)
      .map(e => e.message)
    if (errors.length) {
      return errors
    }

    return null
  }

  generatePayExaminationProps = () => {
    const { ui, master, actions, data } = this.props
    const currentUser = data.viewer
    const paidExamForm = ui.paidExamForm || {}
    return {
      lastName: {
        value: paidExamForm.lastName || '',
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              lastName: v,
            }),
          }),
      },
      firstName: {
        value: paidExamForm.firstName || '',
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              firstName: v,
            }),
          }),
      },
      lastNameKana: {
        value: paidExamForm.lastNameKana || '',
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              lastNameKana: v,
            }),
          }),
      },
      firstNameKana: {
        value: paidExamForm.firstNameKana || '',
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              firstNameKana: v,
            }),
          }),
      },
      fullName: {
        errorTexts: (() => {
          const errors = [].concat(
            this.getPaidExamError('contact_person_family_name'),
            this.getPaidExamError('contact_person_given_name'),
          )
          const displayErrros = errors.filter(e => e != null)
          return displayErrros.length ? displayErrros : null
        })(),
      },
      fullNameKana: {
        errorTexts: (() => {
          const errors = [].concat(
            this.getPaidExamError('contact_person_family_name_kana'),
            this.getPaidExamError('contact_person_given_name_kana'),
          )
          const displayErrros = errors.filter(e => e != null)
          return displayErrros.length ? displayErrros : null
        })(),
      },
      paidMailAddress: {
        value: paidExamForm.paidMailAddress || '',
        errorTexts: this.getPaidExamError('email'),
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              paidMailAddress: v,
            }),
          }),
      },
      companyName: {
        value: paidExamForm.companyName || '',
        errorTexts: this.getPaidExamError('corp_name'),
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              companyName: v,
            }),
          }),
      },
      companyNameKana: {
        value: paidExamForm.companyNameKana || '',
        errorTexts: this.getPaidExamError('corp_name_kana'),
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              companyNameKana: v,
            }),
          }),
      },
      presidentLastName: {
        value: paidExamForm.presidentLastName || '',
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              presidentLastName: v,
            }),
          }),
      },
      presidentFirstName: {
        value: paidExamForm.presidentFirstName || '',
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              presidentFirstName: v,
            }),
          }),
      },
      presidentName: {
        errorTexts: (() => {
          const errors = [].concat(
            this.getPaidExamError('ceo_family_name'),
            this.getPaidExamError('ceo_given_name'),
          )
          const displayErrros = errors.filter(e => e != null)
          return displayErrros.length ? displayErrros : null
        })(),
      },
      presidentLastNameKana: {
        value: paidExamForm.presidentLastNameKana || '',
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              presidentLastNameKana: v,
            }),
          }),
      },
      presidentFirstNameKana: {
        value: paidExamForm.presidentFirstNameKana || '',
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              presidentFirstNameKana: v,
            }),
          }),
      },
      presidentNameKana: {
        errorTexts: (() => {
          const errors = [].concat(
            this.getPaidExamError('ceo_family_name_kana'),
            this.getPaidExamError('ceo_given_name_kana'),
          )
          const displayErrros = errors.filter(e => e != null)
          return displayErrros.length ? displayErrros : null
        })(),
      },
      zipcode: {
        value: paidExamForm.zipcode || '',
        errorTexts: this.getPaidExamError('postal_code'),
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              zipcode: v,
            }),
          }),
      },
      stateList: master.largeAreas || [],
      state: {
        value: paidExamForm.state || '',
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              state: v,
            }),
          }),
      },
      prefectures: {
        value: paidExamForm.prefectures || '',
        errorTexts: this.getPaidExamError('city'),
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              prefectures: v,
            }),
          }),
      },
      street: {
        value: paidExamForm.street || '',
        errorTexts: this.getPaidExamError('address_1'),
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              street: v,
            }),
          }),
      },
      building: {
        value: paidExamForm.building || '',
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              building: v,
            }),
          }),
      },
      phoneNumber: {
        value: paidExamForm.phoneNumber || '',
        errorTexts: this.getPaidExamError('tel'),
        onChange: v =>
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            paidExamForm: Object.assign(paidExamForm, {
              phoneNumber: v,
            }),
          }),
      },
      onClickPayExaminationDryrun: () => {
        window.scrollTo(0, 0)
        actions.createPaidContact({
          userId: currentUser.id,
          param: Object.assign(paidExamForm, {
            is_immediate: true,
            dryrun: true,
          }),
        })
      },
    }
  }

  generatePayExaminationConfirmProps = () => {
    const { ui, actions, data } = this.props
    const currentUser = data.viewer
    const paidExamForm = ui.paidExamForm || {}

    return {
      contactInformationList: [
        {
          title: i18n.t('page.shared.fullName'),
          detail: `${paidExamForm.lastName}　${paidExamForm.firstName}`,
        },
        {
          title: i18n.t('page.shared.fullNameKana'),
          detail: `${paidExamForm.lastNameKana}　${paidExamForm.firstNameKana}`,
        },
      ],
      companyInformationList: [
        {
          title: i18n.t('page.dashboard.reservation.paidMailAddress'),
          detail: paidExamForm.paidMailAddress,
        },
        {
          title: i18n.t('page.shared.companyName'),
          detail: paidExamForm.companyName,
        },
        {
          title: i18n.t('page.shared.companyNameKana'),
          detail: paidExamForm.companyNameKana,
        },
        {
          title: i18n.t('page.shared.presidentName'),
          detail: `${paidExamForm.presidentLastName}　${
            paidExamForm.presidentFirstName
          }`,
        },
        {
          title: i18n.t('page.shared.companyNameKana'),
          detail: `${paidExamForm.presidentLastNameKana}　${
            paidExamForm.presidentFirstNameKana
          }`,
        },
        { title: i18n.t('page.shared.zipcode'), detail: paidExamForm.zipcode },
        {
          title: i18n.t('page.shared.placeName'),
          detail: `${paidExamForm.state}　${paidExamForm.prefectures}`,
        },
        {
          title: i18n.t('page.shared.streetName'),
          detail: paidExamForm.street,
        },
        {
          title: i18n.t('page.shared.buildingName'),
          detail: paidExamForm.building,
        },
        {
          title: i18n.t('page.shared.phoneNumber'),
          detail: paidExamForm.phoneNumber,
        },
      ],
      onClickCancel: () => {
        window.scrollTo(0, 0)
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          isConfirmPaidExamination: false,
        })
      },
      onClickPayExamination: () => {
        actions.createPaidContact({
          userId: currentUser.id,
          param: Object.assign(paidExamForm, {
            is_immediate: true,
            dryrun: false,
          }),
        })
      },
    }
  }

  generatePayExaminationFinishProps = () => {
    const { ui, user, actions } = this.props
    const paidStatus = (user.user || {}).paid_account_status

    return {
      isSuccess: paidStatus === 2,
      onClickBack: () => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          redirectToSelectPayment: true,
        })
      },
    }
  }

  render() {
    const {
      location,
      history,
      match,
      reservationDetail,
      ui,
      user,
      actions,
    } = this.props
    const paidStatus = (user.user || {}).paid_account_status

    // 未承認予約がなければ直リンクした場合はメッセージ画面に戻す
    if (
      reservationDetail.detail.id &&
      !reservationDetail.detail.unapproved_reservation &&
      reservationDetail.detail.status !== SMConst.ReservationStatus.Paying
    ) {
      antdMessage.warning(
        i18n.t('page.dashboard.reservation.error.nothingHostChange'),
      )
      return (
        <Redirect to={Path.reservationDetail(match.params.reservationId)} />
      )
    }

    if (ui.redirectToSelectPayment) {
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        redirectToSelectPayment: false,
      })
      return (
        <Redirect
          to={Path.reservationSelectPayment(match.params.reservationId)}
        />
      )
    }

    return (
      <MainTemplate
        title={i18n.t('server.www.reservationChangeHost.title', {
          id: match.params.reservationId || '',
        })}
        isFixedHeader
        hideMustHeader
        hasFooter={false}
        {...this.props}
      >
        {(() => {
          if (ui.isConfirmPaidExamination && !isNullOrUndefined(paidStatus)) {
            return (
              <ReservationPayExaminationFinishPage
                {...this.generatePayExaminationFinishProps()}
              />
            )
          }
          if (ui.isConfirmPaidExamination) {
            return (
              <ReservationPayExaminationConfirmPage
                {...this.generatePayExaminationConfirmProps()}
              />
            )
          } else {
            return (
              <ReservationPayExaminationPage
                {...this.generatePayExaminationProps()}
              />
            )
          }
        })()}
        {ui.isLoading && <LoadingView />}
      </MainTemplate>
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
    master: state.master,
    user: state.user,
    reservationDetail: state.reservationDetail,
    config: state.config,
  }
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setUIState,
    ...ReservationDetailActions,
    ...UserActions,
    ...MasterActions,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

const WrappedContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(ReservationPayExaminationContainer)),
)

export default WrappedContainer



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationPayExaminationPage/index.jsx